import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import reportWebVitals from "./reportWebVitals";

const App = lazy(() => import("./App"));
const Akiwei = lazy(() => import("./pages/Akiwei/Akiwei"));
const Entry = /^\/akiwei(?:\/|$)/.test(window.location.pathname) ? Akiwei : App;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <HelmetProvider>
        <React.StrictMode>
            <Suspense fallback={<p role="status">頁面載入中…</p>}><Entry /></Suspense>
        </React.StrictMode>
    </HelmetProvider>
);

reportWebVitals();
